<template>
    <div class="pa-0 ma-0">
        <!-- Contenido con órdenes -->
        <v-container fluid class="pt-0 mt-1">
            <v-row>
                <v-col
                    v-for="(order, index) in orders"
                    :key="order.id"
                    cols="6"
                    md="3"
                    class="d-flex"
                >
                    <v-card
                        :class="['order-box', getBoxColor(order)]"
                        elevation="4"
                        class="pa-3 d-flex flex-column justify-space-between"
                    >
                        <!-- Cabecera del pedido -->
                        <v-card-title
                            class="text-subtitle-1 font-weight-bold pa-0"
                        >
                            Pedido #{{ order.number }} — Mesa
                            {{ order.table_number }}
                        </v-card-title>

                        <!-- Productos -->
                        <v-card-text class="py-2 px-0">
                            <ul
                                v-if="order.products && order.products.length"
                                class="pl-4"
                            >
                                <li
                                    v-for="(product, pIndex) in order.products"
                                    :key="pIndex"
                                >
                                    {{ product.name }} x
                                    {{ product.pivot.quantity }}
                                </li>
                            </ul>
                            <div v-else class="no-products">Sin productos</div>
                        </v-card-text>

                        <!-- Temporizador -->
                        <v-card-subtitle
                            class="mt-auto text-right font-weight-medium"
                            :class="{ late: isLate(order) }"
                        >
                            {{ getRemainingTime(order.created_at) }}
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props: ["screenId", "categoryIds", "categoryName"],
    data() {
        return {
            orders: [],
            timerInterval: null,
        };
    },
    mounted() {
        this.getOrders();
        this.listenForNewOrders();

        // Actualiza cada segundo los timers
        this.timerInterval = setInterval(() => {
            this.$forceUpdate();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.timerInterval);
    },
    methods: {
        async getOrders() {
            try {
                const res = await axios.get(`/screen-orders/${this.screenId}`);
                const sortedOrders = res.data.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                );
                this.orders = sortedOrders.slice(0, 6);
            } catch (error) {
                console.error("Error al obtener pedidos:", error);
            }
        },
        listenForNewOrders() {
            window.Echo.channel("orders-channel").listen(".new-order", (e) => {
                const payload = e.orderPayload;
                if (!payload || !payload.category) return;

                const allowed = this.categoryIds.map(String);
                if (!allowed.includes(String(payload.category))) return;

                const newProduct = {
                    id: payload.product_id,
                    name: payload.product_name,

                    pivot: {
                        quantity: payload.quantity,
                    },
                };
                const newOrder = {
                    id: payload.id,
                    table_number: payload.table_number,
                    number: payload.number,
                    remark_order: payload.remark || "",
                    created_at: new Date().toISOString(),
                    products: [newProduct],
                };
                const index = this.orders.findIndex(
                    (o) => o.id === newOrder.id
                );
                if (index > -1) {
                    this.orders[index].products.push(newProduct);
                } else {
                    this.orders = [newOrder, ...this.orders].slice(0, 20);
                }
            });
        },

        getRemainingTime(startTime) {
            const maxTimeMs = 10 * 60 * 1000; // 10 minutos en milisegundos
            const created = new Date(startTime);
            const now = new Date();
            const elapsedMs = now - created;

            const remainingMs = Math.max(0, maxTimeMs - elapsedMs);
            const minutes = Math.floor(remainingMs / 60000)
                .toString()
                .padStart(2, "0");
            const seconds = Math.floor((remainingMs % 60000) / 1000)
                .toString()
                .padStart(2, "0");

            return `${minutes}:${seconds}`;
        },
        isLate(order) {
            const created = new Date(order.created_at);
            const now = new Date();
            return now - created > 5 * 60000; // más de 5 minutos
        },
        getBoxColor(order) {
            const created = new Date(order.created_at);
            const now = new Date();
            const diffMinutes = (now - created) / 60000;

            if (diffMinutes > 10) return "border-red";
            if (diffMinutes > 5) return "border-yellow";
            return "border-green";
        },
    },
};
</script>

<style scoped>
.order-box {
    border: 5px solid #ccc;
    border-radius: 25px;
    padding: 15px;
    width: 100%;
    height: 230px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: monospace;
}

.order-header {
    font-size: 20px;
    text-align: center;
}

.order-body {
    font-size: 16px;
    margin-top: 10px;
    text-align: left;
}

.order-timer {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: orange;
}

.order-timer.late {
    color: red;
}

.comment {
    font-size: 12px;
    font-style: italic;
    margin-top: 5px;
}

.border-red {
    border-color: red !important;
}

.border-yellow {
    border-color: gold !important;
}

.border-green {
    border-color: green !important;
}

.no-products {
    font-style: italic;
    color: #888;
}
</style>
